import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-personnal-data',
  templateUrl: './personnal-data.component.html',
  styleUrls: ['./personnal-data.component.scss']
})
export class PersonnalDataComponent implements OnInit {
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<PersonnalDataComponent>
  ) { }

  ngOnInit(): void {
    this.dialogRef.disableClose = true;
  }  

  onNoClick(): void {
    this.dialogRef.close();
  }
  
}